const iconsMap = {
  "Base/Light Fixture Material":
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/20ac633ddfbccb04d5a2c8c469ed13e6.svg?v=1716786016",
  "Base Colour":
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/900eb032095f25b152bbefe4b8c23a26.svg?v=1716786016",
  "Shade Included":
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/ccb383348d50fa2628557e425a2c3113.svg?v=1716786016",
  "Shade Material":
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/37b8393bb3adb4809ccb983df606adfa.svg?v=1716786016",
  "Shade Colour":
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/2857616d14733ab92ec244e2d15ee618.svg?v=1716786016",
  "Bulb Base Type":
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/b94c968803b35e0325caa0d2f9c3995c.svg?v=1716786016",
  "Number of Lights":
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/b957966b6a1e5c6241560219858ec95a.svg?v=1716786016",
  Wattage:
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/8905a5e1ff0449ad74e6386311f1b7c6.svg?v=1716786016",
  "Is Bulb Included":
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/5bf59bc8dc6bc79421521c4e821db5d6.svg?v=1716786016",

  Dimmable:
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/37fb747866af627eaa3f97722c514d46.svg?v=1716786016",
  Voltage:
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/776d4a5840d35d912b1c98da4736f8b2.svg?v=1716786016",
  "Switch Type":
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/002b591835e156694c29244e0a9d3c3d.svg?v=1716786017",
  "Box Content":
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/7d3d24e29955d5b084b6c41f4ddb2546.svg?v=1716786016",
  "Care Instruction":
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/bd80789b05c3e88386dc27f488803851.svg?v=1716786016",
  "Overall Dimensions(in)":
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/905bd3c9670af5fe45ff963321d7c8ab.svg?v=1716786016",
  "Overall Product Weight (lbs)":
    "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/baeba3b0b1672f5712db614d60a36705.svg?v=1716786016",
};

class ProductSpecs extends HTMLElement {
  constructor() {
    super();
    this._htmlContent = this.innerHTML;
  }

  connectedCallback() {
    const paragraphs = this.querySelectorAll("p");
    const lists = this.querySelectorAll("ul");

    this.headings = [];
    this.overview = null;
    this.specsList = lists[0];
    this.weightAndDimensions = lists[1];
    paragraphs.forEach(p => {
      if (p.querySelector("strong")) {
        p.classList.add("product-specs__heading");
        this.headings.push(p);
      } else {
        this.overview = p;
      }
    });

    console.log(this.getAttribute("data-type"));
    this.render(this.getAttribute("data-type"));
  }

  render = type => {
    switch (type) {
      case "overview":
        this._renderOverview();
        break;
      case "specs":
        this._renderSpecsList();
        break;
      case "weight-and-dimensions":
        this._renderWeightAndDimensions();
        break;
      default:
        this._renderOverview();
    }
  };

  _renderSpecsList() {
    this.specsList.querySelectorAll("li").forEach(li => {
      li.classList.add("product-specs__item");
      const key = li.textContent.split(":")[0];
      const img = document.createElement("img");
      img.src =
        iconsMap[key] ||
        "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/21.svg?v=1716786016";
      img.classList.add("product-specs__icon");
      img.alt = key;
      li.prepend(img);
    });

    this.innerHTML = this.specsList.outerHTML;
  }

  _renderOverview() {
    this.innerHTML = this.overview.outerHTML;
  }

  _renderWeightAndDimensions() {
    this.weightAndDimensions.querySelectorAll("li").forEach(li => {
      li.classList.add("product-specs__item");
      const key = li.textContent.split(":")[0];
      const img = document.createElement("img");
      img.src =
        iconsMap[key] ||
        "https://cdn.shopify.com/s/files/1/0823/4355/9467/files/21.svg?v=1716786016";
      img.classList.add("product-specs__icon");
      img.alt = key;
      li.prepend(img);
    });
    this.innerHTML = this.weightAndDimensions.outerHTML;
  }
}

if (!window.customElements.get("product-specs")) {
  window.customElements.define("product-specs", ProductSpecs);
}
